import api from './api/api';

class SystemService {
  cleanSystem(password, deleteFutureMeetings) {
    return api.post('/admin/system/clean/', {
      password: password,
      delete_future_meetings: deleteFutureMeetings
    });
  }

  exportSystem(password) {
    return api.post('/admin/system/export/', {
      password: password
    }, {
      responseType: 'blob'
    }).then(response => {
      // Trigger download
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;

      // Extract filename from content-disposition header or use default
      const contentDisposition = response.headers['content-disposition'];
      let filename = 'assemblo_export.xlsx';
      if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename="(.+)"/);
        if (filenameMatch) {
          filename = filenameMatch[1];
        }
      }

      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      return response;
    });
  }

  setPinForAdmin(password, userId, pin) {
    return api.post('/admin/system/pins/', {
      password: password,
      user_id: userId,
      pin: pin
    });
  }
}

export default new SystemService();
